<template>
  <configuration-menu-name title="Stilvorlage" :menu="menu" max="255" @update:data="$emit('update:menu', $event)">
    <p>
      Wählen Sie das gewünschte Design Ihrer Speise- und Getränkekarte.<br />
      Alle Designs sind in den Größen A4, A5 und DIN Lang verfügbar (Auswahl im nächsten Schritt).
    </p>
  </configuration-menu-name>
  <div v-if="layouts.length > 0" class="cards row d-flex justify-content-start align-items-stretch">
    <template v-for="(layout, index) in layouts" :key="index">
      <label v-if="format == false || format == layout.attributes.format" class="col-3 cursor-pointer mb-4">
        <input
          :value="layout.id"
          :checked="layout.id == menu.attributes.layout_id"
          type="radio"
          name="layout"
          @change="changeMenuData"
        />
        <base-card-carousel :layout-id="index" :images="layout.attributes.images" :title="layout.attributes.name">
        </base-card-carousel>
      </label>
    </template>
  </div>
  <base-spinner v-else></base-spinner>
</template>

<script>
import { useVModel } from '@vueuse/core';
import { useRouter } from 'vue-router';
import { watch, ref } from 'vue';

import { useGetLayouts } from '@/composables/useLayouts';

import ConfigurationMenuName from '@/components/ConfigurationMenuName';

export default {
  components: {
    ConfigurationMenuName,
  },
  props: {
    menu: { type: Object, default: null },
  },
  emits: ['update:menu'],
  setup(props, { emit }) {
    const { layouts } = useGetLayouts();
    const router = useRouter();

    const menu = useVModel(props, 'menu', emit);

    const changeMenuData = (event) => {
      menu.value = { layout_id: parseInt(event.target.value) };
    };

    watch(
      () => props.menu.id,
      (newMenuId, oldMenuId) => {
        if (oldMenuId !== newMenuId) {
          router.push({ params: { menuid: newMenuId } });
        }
      }
    );

    const format = ref('');
    const filterFormat = (event) => {
      format.value = event.target.value;
    };

    return {
      changeMenuData,
      layouts,
      filterFormat,
      format,
    };
  },
};
</script>
